// import '../assets/app-tailwind.css'

// import React from 'react'
// import { createRoot } from 'react-dom/client'
// import { Provider } from 'react-redux'

// Import React Apps
import './apps/address-form/index.jsx'
import './apps/gwp/index.jsx'

// Components
import { setupVideos } from './components/Video.js'
import { setupPaginations } from './components/Pagination.js'
import { setupPopup } from './components/Popup.js'
import { setupAccordions } from './components/Accordion.js'
import { setupLinkButtons } from './components/LinkButton.js'
import { setupQuickView } from './components/QuickView.js'

// Sections
import { setupHeader } from './sections/header.js'
import { setupHeros } from './sections/hero.js'
import { setupFourUpTabs } from './sections/four-up-products.js'
import { setupCollection } from './sections/collection.js'
import { setupProduct } from './sections/product.js'
import { setupRelatedProducts } from './sections/related-products.js'
import { setupThreeUp } from './sections/three-up.js'
import { setupMediaGrid } from './sections/media-grid.js'
import { setupCart } from './sections/cart.js'
import { setupAccount } from './sections/account.js'
import { setupImageWithTexts } from './sections/image-with-text.js'
import { setupAnimatedTickers } from './sections/animated-ticker.js'
import { setupMediaSliders } from './sections/media-slider.js'
import { setupCustomTexts } from './sections/custom-text.js'
import { setupGalleries } from './sections/gallery.js'
import { setupFooter } from './sections/footer.js'
import { setupContactForm } from './sections/contact-form.js'
import { setupSearch } from './sections/main-search.js'
import { setupBlog } from './sections/main-blog.js'
import { setupCountdownTimer } from './sections/countdown-banner.js'

document.addEventListener('DOMContentLoaded', () => {
  // Sections
  setupHeader()
  setupHeros()
  setupFourUpTabs()
  setupCollection()
  
  if(document.querySelector('[data-section-type="main-product"]')) {
    setupProduct(document.querySelector('[data-section-type="main-product"]').dataset.sectionId)
  }
  setupRelatedProducts()
  setupThreeUp()
  setupMediaGrid()
  setupCart()
  setupAccount()
  setupImageWithTexts()
  setupAnimatedTickers()
  setupMediaSliders()
  setupCustomTexts()
  setupGalleries()
  setupFooter()
  setupContactForm()
  setupSearch()
  setupBlog()
  setupCountdownTimer()

  // Components
  setupVideos()
  setupPaginations()
  setupPopup()
  setupAccordions()
  setupLinkButtons()
  setupQuickView()
})